var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st0","d":"M841.9,102.7H92.4","strokeWidth":"20.5339","strokeMiterlimit":"41.0678","key":0}),React.createElement("path",{"className":"st1","d":"M107.8,205.3C82.1,164.3,42.1,129.4,0,102.7C43.1,77,81.1,41.1,107.8,0l25.7,0c-26.7,41.1-58.5,76-98.6,102.7\n\tc40,27.7,72.9,61.6,99.6,102.7H107.8z","key":1}),React.createElement("path",{"className":"st1","d":"M169.4,205.3c-25.7-41.1-65.7-76-107.8-102.7C104.7,77,142.7,41.1,169.4,0h25.7c-26.7,41.1-58.5,76-98.6,102.7\n\tc40,27.7,72.9,61.6,99.6,102.7H169.4z","key":2})]);
}

ArrowLeftInline.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 841.9 205.3","style":{"enableBackground":"new 0 0 841.9 205.3"},"xmlSpace":"preserve"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
